export default __webpack_public_path__ + "static/media/Combined-Logos.9180961e.png";